import { defaultMaximumPagination, RequestConfig } from 'helpers';
import { XeroAccountType } from 'services/accounting';
import {
  createApiCall,
  DataWithPagination,
  paginatedApiCall,
} from 'services/api';
import { PaginationDirection } from 'services/url';
import { Xero } from './types';
import { transformXero } from './transformations';

export const fetchXeroAuthUrl = async (): Promise<string> => {
  const response = await createApiCall(
    {
      path: '/integrations/xero/auth',
      method: 'GET',
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data;
};

export const exportToXero = async (): Promise<string> => {
  const response = await createApiCall(
    {
      path: '/integrations/xero/export',
      method: 'POST',
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
        success: () => 'Export to Xero successful.',
      },
    }
  )();

  return response.data;
};

export const downloadXeroXml = async () => {
  const response = await createApiCall(
    {
      path: '/integrations/xero_export_xml',
      method: 'GET',
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'fishbowl-online.qwc');
  document.body.appendChild(link);
  link.click();
};

export async function fetchXeroAccountsAPI(
  config: RequestConfig,
  accountType: XeroAccountType | null,
  listId: string[] | null
): Promise<DataWithPagination<Xero>> {
  let page = 1;
  const pageSize = 100;
  let allAccounts: Xero[] = [];
  let hasMore = true;

  while (hasMore) {
    const {
      pagination = defaultMaximumPagination,
      customQuickSearchColumns = ['name'],
      quickSearchValue,
    } = config;
    let path = `/integrations/xero/accounts`;

    if (accountType) {
      path += `?accountType=${accountType}`;
    }

    if (listId && listId.length > 0) {
      path += `${accountType ? '&' : '?'}listId=${listId}`;
    }

    if (quickSearchValue) {
      path +=
        `${accountType || listId ? '&' : '?'}` +
        `quickSearchColumns=${customQuickSearchColumns}&quickSearchValue=${quickSearchValue}`;
    }

    const res = await paginatedApiCall(
      path,
      { ...pagination, page },
      transformXero
    );
    const accounts = res.data || [];
    allAccounts = allAccounts.concat(accounts);
    hasMore = accounts.length === pageSize;
    page++;
  }

  return {
    data: allAccounts,
    pagination: {
      page: page - 1,
      pageSize,
      totalRows: allAccounts.length,
      sort: { sortBy: '', direction: PaginationDirection.Ascending },
    },
  };
}
